import { Typography } from 'shared/ui/Typography'
import { Icon } from 'shared/ui/Icon'
import { type ITooltipProps, Tooltip } from 'shared/ui/Tooltip'
import styles from './styles.module.scss'

export type IDonutChartBar = {
  title: string
  color?: string
  count?: number
  percent: number
  tooltipProps?: ITooltipProps
}

type IDonutChartBarProps = IDonutChartBar

export const DonutChartBar = ({
  title,
  color,
  count = 0,
  percent = 0,
  tooltipProps,
}: IDonutChartBarProps) => {
  return (
    <div className={styles.wrap}>
      <div className={styles.info}>
        <div className={styles.info__container}>
          <div className={styles.info__data}>
            <Typography ariaLabel={'title'} variant={'heading-sm'} className={styles.info__count}>
              {count}
            </Typography>
            <Typography
              ariaLabel={'title'}
              variant={'body-sm-regular'}
              className={styles.info__percent}
            >
              {percent}%
            </Typography>
          </div>

          {tooltipProps && (
            <Tooltip placement={'top'} {...tooltipProps}>
              <Icon
                icon={'question'}
                tertiary
                fontSize={14}
                color={'var(--content-neutral-primary)'}
              />
            </Tooltip>
          )}
        </div>

        {title && (
          <Typography
            ariaLabel={'title'}
            variant={'body-rg-regular'}
            className={styles.info__title}
          >
            {title}
          </Typography>
        )}
      </div>
      <div className={styles.bar}>
        <div
          style={{
            width: percent + '%',
            backgroundColor: color || 'var(--custom-cyan)',
          }}
        />
      </div>
    </div>
  )
}
